<mat-form-field class="w-full" appearance="fill">
  <mat-label>{{ data.name }}</mat-label>
  <input matInput [placeholder]="data.name || ''" [formControl]="dataUpcast" [matDatepicker]="picker" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
